/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sort': {
    width: 5,
    height: 11,
    viewBox: '0 0 5 11',
    data: '<g fill-rule="evenodd"><path pid="0" d="M1.278 6.603A.702.702 0 00.67 7.658l1.293 2.245a.708.708 0 001.224 0L4.48 7.665a.71.71 0 00-.615-1.062H1.278zM1.278 4.254A.702.702 0 01.67 3.2L1.963.954a.708.708 0 011.224 0L4.48 3.192a.71.71 0 01-.615 1.062H1.278z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/sort.js